// Roles: 1 Super Admin, 2 Admin, 3 Manager, 4 Employee, 5 Member.
export const ROLE_SUPER_ADMIN = "1";
export const ROLE_ADMIN = "2";
export const ROLE_MANAGER = "3";
export const ROLE_EMPLOYEE = "4";
export const ROLE_MEMBER = "5";

/**
 * Roles that can be assigned to a staff member. An allowlist rather than an
 * exclusion list, so a role added later is not silently offered here.
 *
 * Super Admin is the built-in owner account and is never handed out; Member
 * belongs to borrowers on the member portal, not to staff.
 */
export const STAFF_ASSIGNABLE_ROLES = [ROLE_ADMIN, ROLE_MANAGER, ROLE_EMPLOYEE];

function currentRole() {
    return String(localStorage.getItem("Role") ?? "");
}

/**
 * Full administrative rights. Admin is deliberately equivalent to Super Admin
 * everywhere in the app; the only thing reserved for Super Admin is the
 * Settings menu, which is withheld through role_menu_access rather than here.
 *
 * Use this for every "can this user manage things" check so the two roles can
 * never drift apart again.
 */
export function isAdmin() {
    const role = currentRole();
    return role === ROLE_SUPER_ADMIN || role === ROLE_ADMIN;
}

/**
 * Super Admin only. Reserved for Settings; prefer isAdmin() for anything else.
 */
export function isSuperAdmin() {
    return currentRole() === ROLE_SUPER_ADMIN;
}
